import {dhtmlXCalendarObject} from '../../../dx/dxSource/components/dhtmlXCalendar';
import {_showClearIcon} from "../../../jsCom/goForm/components/Common_Fun";
import {DateFun} from "goingutils";


//根据参数定义来设置input的值
function _getDateFormat(editorType) {
    if (editorType === "date8") {
        return `%Y%m%d`;
    } else if (editorType === "date14") {
        return `%Y%m%d %H:%i:%s`;
    }
    return `%Y-%m-%d`;
}

function setSens(id, k, inputId) {
    let myCalendar = CalendarUtils.calendarObj[inputId];
    // update range
    if (k == "min") {

        myCalendar.setSensitiveRange(document.getElementById(id).value, null);
    } else {

        myCalendar.setSensitiveRange(null, document.getElementById(id).value);
    }
}

window.setSens = setSens;

let CalendarUtils = {
    //获取编辑区域的数据
    getEditorSubmitData(item, targetObj, backJson) {
        //时间
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    //获取查询区域的数据
    getQuerySubmitData(item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        //开始时间
        backJson[item["id"] + "_ge_date"] = $("#" + inputElId + "_start").val();
        //结束时间
        backJson[item["id"] + "_le_date"] = $("#" + inputElId + "_end").val();
    },
    //清空数据
    clearData(formType, item, targetObj) {
        //如果是查询区域
        if (formType === "query" || formType === "singleQuery") {
            $(`#${targetObj.prefixCls}_${item["id"]}_start`).val("");
            $(`#${targetObj.prefixCls}_${item["id"]}_end`).val("");
        } else {
            let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
            $("#" + inputElId).val("");
        }
    },
    calendarObj: {},
    //初始化日期控件
    initDateCalendar(inputId, editorType, targetObj) {
        let myCalendar = new dhtmlXCalendarObject({
            input: inputId
        });
        myCalendar.loadUserLanguage("ch");
        myCalendar.setDateFormat(
            _getDateFormat(editorType)
        );


        if (targetObj.curCtlObj != null) {
            (targetObj.curCtlObj)[inputId] = myCalendar;
        }else{
            targetObj.curCtlObj={};
            targetObj.curCtlObj[inputId] = myCalendar;
        }
    },
    // 初始化日期范围选择
    initDateRang(inputId) {
        let myCalendar = new dhtmlXCalendarObject([inputId + "_start", inputId + "_end"]);
        myCalendar.setDate(DateFun.formatDate(new Date(), "yyyy-MM-dd"));
        myCalendar.loadUserLanguage("ch");
        myCalendar.hideTime();

        CalendarUtils.calendarObj[inputId] = myCalendar;
        //获取当前对象
        let curDate = new Date();
        //设置开始时间
        if (document.getElementById(inputId + "_start") != null) {
            document.getElementById(inputId + "_start").value = DateFun.formatDate(curDate.getFirstDayOfMonth(), "yyyy-MM-dd");
        }
        //设置结束时间
        if (document.getElementById(inputId + "_end") != null) {
            document.getElementById(inputId + "_end").value = DateFun.formatDate(curDate.getLastDayOfMonth(), "yyyy-MM-dd");
        }
    }
};

export default CalendarUtils;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-calendar-event.js